module.exports = __webpack_public_path__ + "static/media/joinusFood3.cf2738ba.jpg";